import { render, staticRenderFns } from "./List-Shipment-Bag-Detail.vue?vue&type=template&id=7f79693a"
import script from "./List-Shipment-Bag-Detail.vue?vue&type=script&lang=js"
export * from "./List-Shipment-Bag-Detail.vue?vue&type=script&lang=js"
import style0 from "./List-Shipment-Bag-Detail.vue?vue&type=style&index=0&id=7f79693a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports